import { Col, Image, Row } from "antd";

const mediaBase =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/79-i-have-more-ideas-than-i-have-money";

const images = [
  {
    src: `${mediaBase}/businss-today-magazine-cover-portrait.jpg`,
    alt: "Business Today magazine cover featuring Nahil Wijesuriya",
  },
  {
    src: `${mediaBase}/nahil-wijesuriya-seated-office-interview.jpg`,
    alt: "Nahil Wijesuriya seated in his office during the interview",
  },
  {
    src: `${mediaBase}/nahil-wijesuriya-animated-conversation-portrait.jpg`,
    alt: "Nahil Wijesuriya in animated conversation",
  },
  {
    src: `${mediaBase}/nahil-wijesuriya-smiling-at-interview-table.jpg`,
    alt: "Nahil Wijesuriya smiling at the interview table",
  },
  {
    src: `${mediaBase}/nahil-wijesuriya-thoughtful-portrait.jpg`,
    alt: "A thoughtful portrait of Nahil Wijesuriya",
  },
  {
    src: `${mediaBase}/nahil-wijesuriya-speaking-and-gesturing-during-interview.jpg`,
    alt: "Nahil Wijesuriya speaking and gesturing during the interview",
  },
];

const interview = [
  {
    question:
      "You trained as an engineer, worked at sea, and eventually became an entrepreneur. At what point did you realize you were more interested in building businesses than pursuing a career within an organization?",
    answer: [
      "I had a career with the Shipping Corporation. I was involved in managing the technical side of the ships and eventually became Chief Engineer at the Colombo Dockyard. That was a major achievement for me, and I am still proud of it.",
      "While sailing, we also experienced shipping agents around the world. Every port had an agent who was supposed to understand the ship’s requirements, but often the people handling those responsibilities were essentially wharf clerks rather than people who understood ships.",
      "My partner at the time, Captain Lester Wyman, was handling operations, while I was the technical manager. Between us, we understood exactly what a shipowner, captain, or chief engineer required. So we established East West Enterprises as a shipping agency.",
      "At that time, most of the established shipping agencies were owned by lawyers or accountants. We were different because we were seafarers running a shipping agency. When you went on board a ship, you could speak directly to the captain or chief engineer and understand what they needed without them having to explain everything. That allowed us to provide services and materials quickly.",
      "Within about two years, we had become very successful in shipping agency work. We also handled chartering requirements for the Shipping Corporation.",
      "So it was a natural progression. We understood shipping from the inside, which gave us the confidence to expand into other aspects of the industry.",
    ],
  },
  {
    question: "How did your first move into shipowning come about?",
    answer: [
      "There was an interesting opportunity with Sri Lanka Shipping. People often assume that the Shipping Corporation was our first shipowning venture, but Sri Lanka Shipping preceded it.",
      "Robert Senanayake, a younger brother of Dudley Senanayake, approached us and suggested that we acquire a substantial stake in Lanka Shipping, which the family owned, since we already understood the shipping business.",
      "At the time, the company had a ship called St George on charter between the Middle East and Latakia. I asked, ‘Why is the ship on charter? Why don’t we buy it?’",
      "Nihal Amarsinghe, a director with excellent banking relationships, helped arrange the financing. Interestingly, the company did not even have five years of properly audited accounts. The banks were essentially looking at the people involved rather than at the accounts, and they decided to lend us the money.",
      "We bought the ship and repaid the loan within a year. We renamed her Maha Nuwara, which is the Sinhala name for my home, Kandy.",
      "Eventually, we acquired 100 percent of Sri Lanka Shipping. That became an important step in our evolution from a shipping agency to a shipowner, and later into other areas of the maritime industry, including offshore bunkering.",
    ],
  },
  {
    question:
      "What did you see in 1977 that convinced you Sri Lanka was ready for a new kind of business?",
    answer: [
      "We were emerging from a very restrictive economic environment and moving towards the liberalized economy introduced under J R Jayewardene. I thought that this might finally be a time when we could do something ourselves.",
      "The restrictions of the previous period had been extraordinary. Imports were so scarce that people even sent Wilkinson razor blades in envelopes because locally available products were scarce.",
      "The name EastWest Enterprises actually came from an idea I had to trade between East and West. I had originally registered a company in the UK. Later, when we needed a name for a business in Sri Lanka, we used the same name.",
      "We had no grand business plan at the beginning. In fact, the first thing I bought under the EastWest name was 24 Parker pens at a trade discount. I thought I would sell them, but every friend who visited took one as a gift. Within a short time, all 24 were gone, and we had made no business at all! That was EastWest’s first transaction.",
    ],
  },
  {
    question:
      "You have said that you sold your car to put money into the business. How important was that decision?",
    answer: [
      "It was very important because it showed we were willing to put our own money behind the business.",
      "As seafarers, we had accumulated foreign-exchange savings, and at the time, those earnings gave us access to imported cars. I had bought a Toyota, but shortly afterward, I decided to sell it and put the proceeds into EastWest.",
      "We initially thought we would operate from my partner Lester’s home, using an extra room as an office. Eventually, we found a small space at Ceylinco. A gentleman called Hector Silva was retiring and offered us his room. He moved his desk outside and gave us the room. That was essentially our first office.",
      "We had very little money, but we had knowledge, energy, and the willingness to work. Looking back, that was enough to get started.",
    ],
  },
  {
    question:
      "How did EastWest evolve from a shipping agency into a diversified group?",
    answer: [
      "We were never afraid of trading in something if we saw an opportunity. We traded in all sorts of products, including used cars, office equipment, and even typewriters.",
      "One example was Volkswagen Beetles. Germany had stopped producing them, but South Africa was still producing Beetles, and also drove on the same side of the road as Sri Lanka. So we found an opportunity to import them.",
      "Then the accelerated Mahaweli development program created another opportunity. We were handling shipping agency work for project cargo arriving in Sri Lanka. The contractors and their freight forwarders needed the equipment transported from the port to the project sites. We became involved in that port-to-site transportation.",
      "Some of the cargo was extremely heavy and difficult to move. We would sometimes design and build our own trailers to transport specialized equipment. My engineering background proved very useful, as I could understand the technical requirements and design solutions rather than simply relying on someone else.",
      "That is how the business expanded. We were not necessarily looking for a particular industry. We were looking for opportunities to apply what we knew.",
    ],
  },
  {
    question:
      "What made you comfortable repeatedly entering industries in which you were not the established player?",
    answer: [
      "My father used to tell me, ‘What man has done, man can do.’",
      "He also said that if you lack knowledge, you can acquire it. If someone else is working eight hours a day and you need to learn something, you have another 16 hours after allowing for eight hours of sleep.",
      "That philosophy stayed with me. If I didn’t know something, I would learn it. I was never frightened of entering a new field simply because somebody else was already established in it.",
      "We also had a safety net. As seafarers, we were relatively well paid. If everything went wrong in business, we could always return to sea. That gave us a certain fearlessness. I never felt that losing something was the end of the world. Perhaps that is because we were fortunate enough to have had everything we needed growing up. You become less attached to possessions when you don’t feel that you have to hold on to them.",
    ],
  },
  {
    question:
      "You have always been known for being intensely hands-on. Why have you preferred to understand and sometimes do things yourself rather than simply delegate?",
    answer: [
      "Delegating requires communication. You have to explain your ideas, put them on paper, communicate them to someone else, and then wait for the result. If I do something myself, I can usually get it done correctly and, more importantly, I can correct a mistake immediately.",
      "You can’t get everything right all the time. The important thing is how quickly you recognize and correct a mistake.",
      "If you are hands-on, you can see what is happening in the marketplace and in operations. If you are waiting for reports to come back, you may discover a problem only after you have already lost money.",
      "So being hands-on has always been important to me, particularly when something needs to be fixed quickly.",
    ],
  },
  {
    question:
      "Has your engineering background made you more operational than strategic as a businessman?",
    answer: [
      "I have always been mechanically minded. Even my school leaving certificate described me that way.",
      "But I don’t see operational and strategic thinking as opposites. Understanding how something works at the operational level helps you make better strategic decisions.",
      "My approach is to break a large problem into smaller components. A business may look enormous when you look at it as one entity. But if you break it down into its individual parts, each part becomes manageable.",
      "That is something I have also tried to teach my children. When we were building the Marriott, for example, two of my children were involved. You don’t look at the entire project and say, ‘This is impossible.’ You take one component at a time and deal with it.",
    ],
  },
  {
    question:
      "You have said that businesses need freedom. What does freedom to do business mean to you?",
    answer: [
      "It means deregulation. Sri Lanka is heavily over-regulated. We have created so many restrictions, permissions, and forms that even simple activities can become unnecessarily complicated.",
      "Lawmakers naturally focus on preventing negative consequences, but in doing so, they can end up regulating positive aspects as well. You need to accept that freedom comes with some negative consequences, but its benefits are usually much greater.",
      "Years ago, when the internet was becoming available, we created something called ‘How To’ guides. For example, how to obtain a birth certificate or how to get a building plan approved. We tried to explain the forms and procedures so people could understand what they had to do before going to the relevant office.",
      "That was because even obtaining a form could become an exercise in itself.",
      "If we want the country to work efficiently, we need fewer regulations and more freedom for people to do business.",
    ],
  },
  {
    question:
      "What could an entrepreneur do in 1977 that would be difficult to do today, and what can today’s entrepreneur do that would have been impossible then?",
    answer: [
      "When we started, competition was almost nonexistent because the economy had been so restricted.",
      "There were only a handful of companies that knew how to conduct international trade or open letters of credit. If you were starting a business at the beginning of liberalization, you could find opportunities very quickly because there were very few competitors.",
      "Today, competition is intense. Anyone who has worked overseas or developed a network of contacts can enter the market. The difference is that today’s entrepreneur has access to technology, information, and communication that we could never have imagined.",
      "So the opportunities are still there, but you have to be smarter because everyone has access to the same tools.",
    ],
  },
  {
    question:
      "You have previously described Sri Lanka as an expensive place to do business because of inadequate infrastructure. Has that changed?",
    answer: [
      "It has changed considerably in some respects. Road infrastructure has improved enormously. Telecommunications have also transformed the way we do business.",
      "We have gone from telegrams and letters that took weeks to arrive, to telephones, then mobile phones, and now smartphones. The world has changed dramatically.",
      "But there is an important point: we are consumers of most of this technology. We didn’t invent the smartphone or the internet. We have adopted technologies developed elsewhere.",
      "The advantage today is that communication is faster and cheaper. But because everyone has access to the same technology, you no longer have an advantage simply because you have a telephone or internet connection. You have to find another advantage.",
    ],
  },
  {
    question:
      "After almost five decades in business, what has the changing Sri Lankan business environment taught you?",
    answer: [
      "One thing I have learned is that the rules keep changing.",
      "Every government that comes into power tends to say that the previous government was full of rogues. Then, when the next government comes in, it says the same thing about its predecessor.",
      "We have had too much political interference in business and too much regulation.",
      "I am a free-market person. I believe that markets should be allowed to work and that government should create the conditions for business rather than trying to run businesses itself.",
      "My engineering background proved very useful, as I could understand the technical requirements and design solutions rather than simply relying on someone else. That is how the business expanded. We were not necessarily looking for a particular industry. We were looking for opportunities to apply what we knew.",
    ],
  },
  {
    question:
      "Sri Lanka is often described as a country with enormous potential. What needs to happen for that potential to translate into sustained economic growth?",
    answer: [
      "I don’t like the phrase ‘Sri Lanka has enormous potential.’ Potential doesn’t mean anything unless you explain how you are going to realize it.",
      "We need to examine the mistakes we have made over the years.",
      "We have repeatedly moved from one extreme to another – nationalization and then privatization, excessive regulation followed by attempts at liberalization, and policies that changed with governments.",
      "We have also allowed politicians with very little commercial experience to make decisions about business.",
      "A small shopkeeper may understand business better than a minister because the shopkeeper has actually had to make money, pay employees, manage stock, and deal with customers. We have become over-governed and over-regulated.",
    ],
  },
  {
    question: "Where do you see Sri Lanka’s real economic opportunity?",
    answer: [
      "We need to be realistic about our scale. Manufacturing is difficult when you are competing with India or China because their domestic markets are enormous. Economies of scale matter.",
      "If you produce something for a market of hundreds of millions of people, you can achieve costs that a small country cannot match.",
      "So I would not tell Sri Lanka to try to compete with China in everything. We should focus on areas where scale is less important, particularly services and specialized activities.",
      "We often talk about our geographical location as an advantage. But communication and logistics have changed so much that location no longer automatically gives you an advantage.",
      "We need to identify precisely what we can do better than others and then build around that.",
    ],
  },
  {
    question:
      "You often criticize political leaders for announcing big ideas without explaining how they will be achieved. What do you think is missing?",
    answer: [
      "The baby steps. Politicians often talk about the destination: ‘We will do this, we will build that, and we will transform the economy.’ But where are the steps that get you there?",
      "When you look at the large companies today, we were all underdogs once.",
      "I understand what it feels like to start with very little and compete with established players.",
      "I don’t mind taking on a large company if I believe it is bullying someone smaller. There is a certain satisfaction in making the larger party sit down and negotiate.",
    ],
  },
  {
    question:
      "You have never appeared particularly interested in public positions or personal glory. Why?",
    answer: [
      "I don’t see much value in positions. Taking a position can sometimes mean putting yourself into a system where you have to deal with things you don’t really want to.",
      "I have always preferred to create businesses and solve problems. I have also been fortunate never to have felt the need to prove myself through titles.",
      "I owe a great deal to my parents and my school, Trinity College, Kandy. Beyond that, I have simply tried to do what interested me.",
    ],
  },
  {
    question:
      "You have maintained a relatively simple lifestyle despite your wealth. Is that deliberate?",
    answer: [
      "I think it comes naturally to me. A friend once told me, ‘Being poor is very expensive because when you are poor, you have to buy things to look rich.’",
      "There is some truth in that. If you have to demonstrate your wealth through expensive labels, cars, and other possessions, you are constantly spending money to prove something. I have never been particularly interested in that.",
      "I have more ideas than I have money. I would rather put money into an interesting project than into something that simply makes me look wealthy.",
    ],
  },
  {
    question:
      "You have even been known to travel economy. Why don’t you spend more on personal comfort?",
    answer: [
      "I don’t see the point of paying a huge amount simply to sit in a more comfortable seat for eight hours.",
      "If the difference between economy and business class is a million rupees, I can think of many better uses for that money.",
      "I have also kept vehicles for decades. I used one Toyota Land Cruiser for roughly 35 years.",
      "It wasn’t even something I originally planned to buy. Toyota had obtained permission for a limited number of seven-seater vehicles to be classified in a way that attracted a lower duty. They offered me one, and I took it.",
      "I used it for decades. When we were working on the Marriott, it was still being used.",
      "My approach is to break a large problem into smaller components. A business may look enormous when you look at it as one entity. But if you break it down into its individual parts, each part becomes manageable.",
    ],
  },
  {
    question:
      "Why have you been willing to give businesses away or sell them to people who worked with you?",
    answer: [
      "Because I am not attached to possessions.",
      "When I built E-wis, Just In Time, Computerland, or EastWest Clearing and Forwarding, I was happy when people who had worked with those businesses eventually took them over.",
      "With EastWest Clearing and Forwarding, for example, Dan Mukundan had the experience to run the company but was initially hesitant about taking it over. I told him we would operate it together for a year without board meetings. He could learn the business and then take it forward. We also structured the equipment so that the business could afford it. I sold the equipment to another company and had it leased back to him, allowing the business to pay for it from its earnings.",
      "That is how I like to create businesses – build them, make them viable, and then let other people take them forward.",
    ],
  },
  {
    question:
      "You have also given substantial amounts to schools and other causes, often without publicity. What motivates that?",
    answer: [
      "It isn’t really a grand philanthropic plan. Most of it has been impulsive. If you see a problem that you can solve, you solve it.",
      "For example, when the grounds at Asgiriya were being expanded, the Trinity College clubhouse had to be demolished. The replacement costs about three million rupees. I had about 3.5 million available at the time, so I gave three million to the college. There was no complicated decision-making process.",
      "It is the same way I look at helping individuals. If somebody’s house is on fire and you have a bucket of water, you don’t stop to ask whether it is your responsibility to put out the fire. You simply do it. That is how I have always reacted.",
    ],
  },
  {
    question: "Is your support for education rooted in what Trinity College gave you?",
    answer: [
      "My school gave me a great deal, particularly through the friendships I made there.",
      "A lot of people talk about how much they owe their school. I certainly feel that way.",
      "I started helping Trinity College long before the recent donation, when the college had smaller requirements. One example was when the college needed a bowling machine. They wanted one so the cricketers could practice against quality bowling.",
      "I arranged for the first bowling machine in Sri Lanka to be sent to the college, even before the Cricket Board had one. Of course, they were still getting beaten despite having the bowling machine. So somebody joked that perhaps they needed a batting machine as well!",
      "Those are the kinds of things I enjoy doing for the institutions and people that have meant something to me.",
    ],
  },
  {
    question:
      "Why do you believe that giving children large amounts of inherited wealth can be harmful?",
    answer: [
      "I believe giving children unearned wealth can set them up for a bad start.",
      "If a child has a large fixed deposit generating income, there is little incentive to start something small. They won’t necessarily begin by selling peanuts at Galle Face or starting a tiny business because they already have a certain standard of living.",
      "Instead, they may feel that their first business must be something big enough to exceed what they already have. That sets the bar too high. This is one reason why the second generation can sometimes destroy what the first generation built. You give them too much comfort, removing the need to struggle.",
    ],
  },
  {
    question:
      "So is that why you are giving away a substantial part of your wealth rather than keeping it within the family?",
    answer: [
      "Where are you going to take it – to the grave?",
      "I don’t see the point in accumulating wealth simply for its own sake.",
      "My children have enough opportunities to build their own lives. I would rather use the wealth to do something useful now.",
      "I also don’t believe that children should inherit an enormous financial cushion that removes their motivation to create something themselves.",
    ],
  },
  {
    question:
      "You have said that much of your philanthropy has been spontaneous rather than planned. Is that also how you have lived your life?",
    answer: [
      "Very much so. A lot of my life has been a series of accidents and impulsive decisions. Even my decision to become a marine engineer happened almost by accident.",
      "I didn’t have enough A-level credits to enter university in Sri Lanka. During my apprenticeship at Walkers, I realized that the people who had completed their apprenticeships were going into fairly routine jobs.",
      "I wanted a proper university education, so I looked through the university information available at the British High Commission and found that Sri Lankans could study overseas if the particular course was not available locally.",
      "I found a course in mechanical and production engineering that wasn’t available in Sri Lanka. I sent applications to several universities. Leicester replied that I appeared to be qualified. I obtained the necessary permissions and was in Britain within about 20 days.",
    ],
  },
  {
    question: "How did you end up going to sea?",
    answer: [
      "Again, it was an accident. While I was in Britain, a friend who had trained as a marine engineer was looking for a job. We went around the shipping companies in London. He applied to P&O but was rejected, partly because of his long hair during the Flower Power era.",
      "I then decided to apply. I got through the aptitude test and was offered a job on a ship in Tilbury. I called my father and told him I wasn’t taking my flight home because I was going to sea. He said, ‘You must be crazy. You can’t even swim.’",
      "I told him that even if I couldn’t swim in the middle of the Atlantic, I would always wear a life jacket. That is how my career at sea began.",
    ],
  },
  {
    question:
      "You have built, diversified, sold, and reinvented businesses throughout your life. At this stage, how do you define success?",
    answer: [
      "Keep it simple. Spend less than you earn. Don’t spend what you don’t have.",
      "You have to limit your wants to what you can afford. It applies to individuals and to governments.",
      "When a government continually spends more than it earns, it eventually gets into trouble. The same principle applies to a person or a company.",
      "Success isn’t necessarily about how much you own. For me, it is about being free to pursue what interests me, not being burdened by debt, and helping people when the opportunity arises.",
    ],
  },
  {
    question:
      "You are a Singaporean citizen, but continue to regard Sri Lanka as home. Why?",
    answer: [
      "I became a Singaporean about 20 years ago, mainly because the passport makes travel easier. But home is where your friends are, and my home is still here.",
      "I have done considerable property business in Singapore and made good money there. I still have an apartment there, and every time I see the rent being paid, I think, ‘I haven’t been to Singapore.’",
      "So I get on a plane, spend a week there, and come back. The apartment is also open to my friends. I don’t see the point of keeping it simply for myself.",
      "I have often sided with the underdog because large organizations can sometimes bully smaller people simply because they have more resources. I enjoy the challenge of taking on someone bigger, provided you know what you are getting into.",
    ],
  },
  {
    question: "Finally, what advice would you give the younger generation?",
    answer: [
      "Don’t do boring things. If you keep doing the same thing, you will eventually get bored. Find something new and exciting.",
      "The world is a very big place. There are enormous opportunities out there.",
      "I have always believed that you should keep moving, keep learning, and keep creating. Once you have completed one thing, don’t be afraid to let it go and move on to the next.",
    ],
  },
];

export const IHaveMoreIdeasThanIHaveMoney = () => {
  return (
    <article style={{ background: "#fffdfa", padding: "10px" }}>
      <Row justify="center">
        <Col xs={24} lg={20} xl={18}>
          <header style={{ margin: "32px auto 40px", textAlign: "center" }}>
            <p
              style={{
                color: "#a36328",
                fontSize: "12px",
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              }}
            >
              Business Today · September 2026
            </p>
            <h1 id="70-i-have-more-ideas-than-i-have-money">
              Nahil Wijesuriya: “I Have More Ideas Than I Have Money”
            </h1>
            <p style={{ color: "#5e665f", fontSize: "18px" }}>
              Nahil Wijesuriya, Chairman and CEO, EastWest Group of Companies.
            </p>
          </header>

          <Image
            alt={images[1].alt}
            preview={{ mask: "View image" }}
            src={images[1].src}
            style={{ maxHeight: "680px", objectFit: "cover", width: "100%" }}
          />

          <div style={{ fontSize: "17px", lineHeight: 1.75, margin: "40px auto", maxWidth: "860px" }}>
            <p>
              Nahil Wijesuriya is a businessman whose entrepreneurial journey
              has been shaped by an instinct to identify opportunities, take
              calculated risks, and remain closely involved in the businesses
              he builds. As Chairman and CEO of the EastWest Group of
              Companies, he built and managed interests spanning real estate,
              shipping, bunkering, information technology, electronic media,
              and financial services, moving across industries while
              maintaining a distinctly hands-on approach to business.
            </p>
            <p>
              Speaking with Business Today, Wijesuriya reflects on the
              influences that shaped his entrepreneurial character, the origins
              and evolution of EastWest, and the lessons accumulated over
              decades of doing business across diverse industries.
            </p>
            <p>
              He discusses the importance of understanding an opportunity
              before committing to it, the value of remaining involved in the
              businesses he leads, and how his approach has evolved as the scale
              and complexity of his interests have grown.
            </p>
            <p>
              <strong>Words:</strong> Jennifer Paldano Goonewardane.
              <br />
              <strong>Photography:</strong> Rasanga Dissanayake and Sujith
              Heenatigala.
            </p>
          </div>

          <Row gutter={[16, 16]} style={{ marginBottom: "42px" }}>
            <Col xs={24} md={8}>
              <Image alt={images[0].alt} src={images[0].src} style={{ width: "100%" }} />
            </Col>
            {images.slice(2, 4).map((image) => (
              <Col xs={24} md={8} key={image.src}>
                <Image
                  alt={image.alt}
                  preview={{ mask: "View image" }}
                  src={image.src}
                  style={{ aspectRatio: "3 / 4", objectFit: "cover", width: "100%" }}
                />
              </Col>
            ))}
          </Row>

          <div style={{ margin: "0 auto", maxWidth: "860px" }}>
            {interview.map((item, index) => (
              <section key={item.question} style={{ marginBottom: "44px" }}>
                <h2 style={{ fontSize: "24px", lineHeight: 1.35 }}>
                  {item.question}
                </h2>
                {item.answer.map((paragraph) => (
                  <p key={paragraph} style={{ fontSize: "17px", lineHeight: 1.75 }}>
                    {paragraph}
                  </p>
                ))}
                {(index === 7 || index === 16) && (
                  <Image
                    alt={images[index === 7 ? 4 : 5].alt}
                    preview={{ mask: "View image" }}
                    src={images[index === 7 ? 4 : 5].src}
                    style={{ marginTop: "16px", maxHeight: "620px", objectFit: "cover", width: "100%" }}
                  />
                )}
              </section>
            ))}
          </div>

          <footer
            style={{ borderTop: "1px solid #d8d1c5", margin: "24px auto 48px", maxWidth: "860px", paddingTop: "24px" }}
          >
            <a
              href="https://businesstoday.lk/nahil-wijesuriya-i-have-more-ideas-than-i-have-money/"
              rel="noreferrer"
              target="_blank"
            >
              Read the original article on Business Today
            </a>
          </footer>
        </Col>
      </Row>
    </article>
  );
};